export default {
    index: "Dashboard",
    users: "Nutzer",
    organisations: "Lieferanten",
    "settings-loginProviders": "Login Methoden"
}
